import { combineReducers } from 'redux';
import formReducer from './form';
import dirty from './dirty';
import requirementsReducer from './requirements';

export default combineReducers({
  form: formReducer,
  dirty,
  requirements: requirementsReducer,
});



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/reducers/index.js